import React from "react";
import { GeneralTemplate } from "../../Templates/GeneralTemplate";

export const General = () => {
  return <GeneralTemplate />;
};
